import React, { useState } from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FormProvider, useForm, useFormContext } from "react-hook-form";

const BankFile = ({ bankList = [], onSubmit, show = false, handleClose }) => {
  const { register, handleSubmit, getValues } = useFormContext();

  const supportedBanks = bankList.filter(
    (b) => b.bankShortCode === "DBS"
  );

  const [activeBank, setActiveBank] = useState(
    supportedBanks?.[0]?.bankShortCode,
  );

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header className="border-0">
        <h4 className="modal-title">Generate Bank File</h4>
        <button type="button" className="close" onClick={handleClose}>
          ×
        </button>
      </Modal.Header>

      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)} className="needs-validation">
          {/* Tabs */}
          <ul className="nav nav-tabs mb-3">
            {supportedBanks.map((bank) => (
              <li className="nav-item" key={bank.bankShortCode}>
                <Link
                  className={`nav-link ${
                    activeBank === bank.bankShortCode ? "active" : ""
                  }`}
                  to="#"
                  onClick={() => setActiveBank(bank.bankShortCode)}
                >
                  {bank.bankName}
                </Link>
              </li>
            ))}
          </ul>

          {/* Tab Content */}
          {supportedBanks.map(
            (bank) =>
              activeBank === bank.bankShortCode && (
                <div key={bank.bankShortCode}>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Bank</label>
                      <input
                      {...register("bankName", { required: false })}
                        className="form-control"
                        value={bank.bankName}
                        readOnly
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label className="form-label">Organisation ID</label>
                      <input
                      {...register("organisationId", { required: false })}

                        className="form-control"
                        value={bank.organisationId}
                        readOnly
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Company Account Number
                      </label>
                      <input
                      {...register("accountNumber", { required: false })}
                        className="form-control"
                        value={bank.accountNumber}
                        readOnly
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Originating Name / On Behalf Of
                      </label>
                      <input
                        className="form-control"
                        {...register("organisationName", { required: false })}
                        placeholder="Company Name"
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label className="form-label">Pay Date</label>
                      <input
                        type="date"
                        className="form-control"
                        {...register("payDate", { required: false })}
                        defaultValue={getValues("payDate")}
                      />
                    </div>
{/* 
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Pay Time</label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("payTime", { required: false })}
                      />
                      <span className="form-text text-muted">(HHMM Format : 2032 (08:32 PM))</span>
                    </div> */}
                  </div>
                </div>
              ),
          )}

          {/* Footer */}
          <div className="text-end mt-4">
            <button
              type="button"
              className="btn btn-secondary me-2"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              Generate Bank File
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

BankFile.propTypes = {
  bankList: PropTypes.array.isRequired,
  userData: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default BankFile;
